import React from 'react'

export default (props)=>{
  return(
    <svg className={["ChevronLeft", "Icon", props.className].filter(Boolean).join(' ')} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path strokeWidth="1" fillRule="evenodd" d="M10.4,1.6c0.2,0.2,0.2,0.5,0,0.7L4.7,8l5.6,5.6c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0l-6-6l0,0,c-0.2-0.2-0.2-0.5,0-0.7l6-6l0,0C9.8,1.5,10.2,1.5,10.4,1.6L10.4,1.6z"/>
    </svg>
  )
}
